import { splice, push, freeze } from 'icepick';
import {
	CARD_DELETE,
	CARD_DELETE_REQUEST,
	type CardDeleteRequestAction,
	type CardDeleteAction,
} from '../../../../actions/cards/delete/index.tsx';
import type { CardsMoveRequestAction } from '../../../../actions/cards/move/index.tsx';
import {
	type CardSingleSelect,
	type CardToggleSelection,
	CARD_SINGLE_SELECT,
	CARD_TOGGLE_SELECTION,
	CARD_MULTI_SELECT,
	type CardMultiSelect,
	CARD_EMPTY_SELECTION,
	type CardEmptySelection,
	type CardMultiSelectExtend,
	CARD_MULTI_SELECT_EXTEND,
	type CardMultiRemove,
	CARD_MULTI_REMOVE,
} from '../../../../actions/cards/selection/index.tsx';
import {
	CARDS_BULK_OPERATIONS_DELETE_SUCCESS,
	type CardsBulkOperationsDeleteSuccessAction,
} from '../../../../actions/cards/bulk-operations-delete/index.tsx';
import type { SelectedState } from './types.tsx';

const initialState = freeze([]);

export type Action =
	| CardToggleSelection
	| CardSingleSelect
	| CardMultiSelect
	| CardEmptySelection
	| CardDeleteRequestAction
	| CardsMoveRequestAction
	| CardDeleteAction
	| CardMultiSelectExtend
	| CardMultiRemove
	| CardsBulkOperationsDeleteSuccessAction;

export const selectedReducer = (
	state: SelectedState = initialState,
	action: Action,
): SelectedState => {
	if (action.type === CARD_TOGGLE_SELECTION) {
		const { cardId } = action.payload;
		const selectedCardIndex = state.indexOf(cardId);

		return selectedCardIndex === -1 ? push(state, cardId) : splice(state, selectedCardIndex, 1);
	}

	if (action.type === CARD_SINGLE_SELECT) {
		const { cardId } = action.payload;
		return [cardId];
	}

	if (action.type === CARD_MULTI_SELECT) {
		return action.payload.cardIds;
	}

	if (action.type === CARD_EMPTY_SELECTION) {
		return initialState;
	}

	if (action.type === CARD_DELETE_REQUEST || action.type === CARD_DELETE) {
		const { cardId: deletedCardId } = action.payload;
		return state.filter((cardId) => cardId !== deletedCardId);
	}

	if (action.type === CARD_MULTI_SELECT_EXTEND) {
		const { cardIds } = action.payload;
		return [...new Set([...state, ...cardIds])];
	}

	if (action.type === CARD_MULTI_REMOVE) {
		const { cardIds } = action.payload;
		return state.filter((cardId) => !cardIds.includes(cardId));
	}

	if (action.type === CARDS_BULK_OPERATIONS_DELETE_SUCCESS) {
		const cardIds = action.payload;
		return state.filter((cardId) => !cardIds.includes(cardId));
	}

	return state;
};
